//E.L variable used to initialize the default export properties.
const device = Object.freeze({
  PHONE: 1000,
  TABLET: 2000,
  DESKTOP: 3000,
});

// E.L
// Using an ES6 feature called computed property name to declare dynamic object keys. i.e [device.PHONE]
// This allows us to define the object keys by the property defined in device instead by their numeric value. i.e instead of 1000
export default Object.freeze({
  [device.PHONE]: {
    IMAGE_PREFIX: "sm",
  },
  [device.TABLET]: {
    IMAGE_PREFIX: "md",
  },
  [device.DESKTOP]: {
    IMAGE_PREFIX: "md",
  },
  ...device,
});
